<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
    (click)="activeModal.close(false)">
  </button>
</div>
<div class="modal-body">
  <p *ngIf="message"><strong>{{ message }}</strong></p>
  <div *ngIf="richMessage" [innerHtml]="richMessage"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary"
    (click)="activeModal.close(false)">{{ cancelButtonText }}</button>
  <button type="button" ngbAutofocus class="btn btn-{{ okButtonColor }}" (click)="activeModal.close(true)">{{ okButtonText }}</button>
</div>